<div class="cc-action-button">
    <dx-drop-down-button
        #actionDropdownButton
        [id]="elementId"
        text="Action"
        icon="runner"
        dropDownContentTemplate="dropDownContentTemplate"
        [showArrowIcon]="false"
        [elementAttr]="{ rowIndex: rowIndex }"
    >
        <div *dxTemplate="let content of 'dropDownContentTemplate'">
            <dx-menu
                #actionMenu
                displayExpr="name"
                cssClass="menu-items"
                orientation="vertical"
                itemTemplate="items"
                [hideSubmenuOnMouseLeave]="true"
                [showFirstSubmenuMode]="{ name: 'onHover', delay: { show: 0, hide: 300 } }"
                [items]="allowedActionMenus"
                (onItemClick)="onItemClick($event.itemData, record, rowIndex)"
            >
                <div
                    *dxTemplate="let item of 'items'"
                    id="menutemplate"
                    class="menu-template cc-menu-template-with-hover"
                >
                    <div
                        class="menu-item-container"
                        [ngClass]="{
                            'menu-separator dx-theme-border-color': item.separator
                        }"
                    >
                        <div *ngIf="!!item.icon" class="menu-icon">
                            <i [class]="item.icon" [ngClass]="{ 'cc-menu-disabled': item.disabled }"></i>
                        </div>
                        <div *ngIf="!item.icon" class="no-icon-padding"></div>
                        <div class="menu-text" [ngClass]="{ 'cc-menu-disabled': item.disabled }">
                            {{ item.name }}
                            <app-security-info
                                *ngIf="item.securityIndicator"
                                cssClass="grid-action-security-icon"
                                [securityIndicator]="item.securityIndicator"
                                [apiAction]="item.apiAction"
                                [apiUrl]="item.apiUrl"
                            ></app-security-info>
                        </div>
                        <div *ngIf="item?.items?.length > 0" class="menu-arrow-icon">
                            <i class="{{ iconNext }}" [ngClass]="{ 'cc-menu-disabled': item.disabled }"></i>
                        </div>
                    </div>
                </div>
            </dx-menu>
        </div>
    </dx-drop-down-button>
</div>
